// extracted by mini-css-extract-plugin
export var parsedContent = "parsed-content-module--parsed-content--juSYI";